<div class="index-ticker-wrapper" [ngStyle]="{'top.px': indexTickerTopOffset}">
    <div class="index-ticker-container flex-centered-container-vr gap-4-px">
        <div class="bg-index-watch full-width flex-centered-container">
            <ng-container *ngFor="let symbol of indexSymbols | slice:0:maxVisibleIndexes">
                <div class="flex-centered-container pinned-symbols" [ngClass]="{'large-indexName': symbol.value.title.length > 10}">
                    <div class="flex-centered-container-vr pinned-mat-card">
                        <div class="flex-centered-container font-inter-semibold font-12 title-name">{{symbol.value.title}}</div>
                        <div class="no-margin font-12 pad-4-hr width-value"
                            [ngClass]="getClass(symbol.value.changeInPrice)">
                            <span class="fixed-numeric-width ticker-ltp">{{symbol.value.ltp |
                                localeConverter: 2: true: true | nullCheck}} </span>
                        </div>
                        <div class="font-10 flex-centered-container fixed-numeric-width ticker-change-percent flex-centered-container-vr" [ngClass]="{'change-percent-positive-box': symbol.value.changeInPrice >= 0, 'change-percent-negative-box': symbol.value.changeInPrice < 0}">
                            {{symbol.value.changeInPrice | localeConverter: 2: true: true |
                                nullCheck}}({{symbol.value.changePercent | localeConverter: 2: true: true |
                            percentPipe: 1 |
                            nullCheck}})
                        </div>
                        <mat-icon [ngClass]="{'text-green': symbol.value.changeInPrice >= 0, 'text-negative-change': symbol.value.changeInPrice < 0}">{{symbol.value.changeInPrice >= 0 ? 'arrow_drop_up' : 'arrow_drop_down'}}</mat-icon>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
    
    <div class="menu-button-fixed cursor-pointer" 
        (click)="openIndexWatch()">
        <mat-icon class="settings-icon">settings</mat-icon>
    </div>
</div>
